var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('NOTHAVEPRIZE',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }